import React from "react";
import { Link } from "wouter";
import './ItemCampain.scss'

const ItemCampain = ({ title, icon, url }) => {
  return (
    <Link href={url} >
      <div className="main-home__item s-cross-center s-main-center box">
        <img src={icon} alt="inbound" className="mt-10" />
        <h3 className="mt-25 mb-15 source-20 s-main-center">
          <span>{title}</span>  
        </h3>
      </div>
    </Link>
  );
};

export default ItemCampain;
